var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9505 13.1836L14.8339 14.8502L20.1339 5.70024L23.8839 12.1836L19.5505 14.6836L28.6505 17.1169L31.1005 8.01691L26.7672 10.5169L23.0172 4.01691C22.7996 3.63692 22.509 3.30376 22.162 3.03667C21.8151 2.76958 21.4186 2.57383 20.9956 2.46072C20.5726 2.34761 20.1314 2.31937 19.6975 2.37765C19.2635 2.43592 18.8454 2.57955 18.4672 2.80024C18.0172 3.05024 17.6339 3.41691 17.3505 3.85024M16.6672 33.3336V30.0002H6.10052L9.83385 23.5002L14.1672 26.0002L11.7339 16.9002L2.61719 19.3336L6.95052 21.8336L3.20052 28.3336C2.9161 28.827 2.76264 29.3849 2.75472 29.9544C2.74681 30.5238 2.88471 31.0859 3.15532 31.587C3.42592 32.0881 3.82022 32.5117 4.30073 32.8174C4.78123 33.1231 5.33195 33.3008 5.90052 33.3336M31.7672 19.1669L28.8672 20.8336L34.1672 30.0002H26.6672V25.0002L20.0005 31.6669L26.6672 38.3336V33.3336H34.1672C36.0172 33.3336 37.5005 31.8502 37.5005 30.0002C37.5005 29.4836 37.3672 28.9669 37.1339 28.5169L31.7672 19.1669Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilIcon);
export default __webpack_public_path__ + "static/media/util_icon.8b9b2b802ba3fe53a440d320508ab239.svg";
export { ForwardRef as ReactComponent };